module.exports = __webpack_public_path__ + "static/media/hero_beach_getty.00f22c0f.jpg";